import { ValiError } from 'valibot';

import { API } from '@/api';
import { fetcher, HTTPError, logger } from '@/services/fetcher';

import { lookupCodeListApiSchema } from '../../models';

const masterDataApi = fetcher.extend(() => ({
  prefixUrl: `${API.MASTER_DATA_PUBLIC}`,
}));

export const fetchLookupCodesList = async (
  lookupCodeType: string,
  keys?: number[],
  { signal, search }: { signal?: AbortSignal; search?: string } = {},
) => {
  try {
    const searchParams: Record<string, string> = {};
    if (keys?.length) {
      searchParams['inlinesearch[id]'] = `in:${keys.join(',')}`;
    }
    if (search) {
      searchParams['inlinesearch[codeDesc]'] = search;
    }

    return await masterDataApi
      .get(`lookup-code/${lookupCodeType}`, {
        searchParams: Object.keys(searchParams).length ? searchParams : undefined,
        signal,
      })
      .json(lookupCodeListApiSchema);
  } catch (error) {
    if (error instanceof ValiError) {
      logger.warn('Validation error on lookup codes response', error.issues);
    }

    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }

    throw error;
  }
};
